import styled from 'styled-components';

export const StyledMarketHolidayAlert = styled.div`
  background: var(--lightYellow);
  color: var(--outerSpace);
  padding: 1rem 2rem;
  margin-bottom: 1rem;
`;
